export default "__VITE_ASSET__CulBl$Xv__"